// Service Worker Registration untuk PWA Cadira
// Online-first: cache static assets, offline fallback page

const isLocalhost = Boolean(
	window.location.hostname === 'localhost' ||
		window.location.hostname === '[::1]' ||
		window.location.hostname.match(
			/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
		)
);

function registerValidSW(swUrl, config) {
	navigator.serviceWorker
		.register(swUrl)
		.then((reg) => {
			const registration = reg;
			registration.onupdatefound = () => {
				const installingWorker = registration.installing;
				if (installingWorker == null) return;

				installingWorker.onstatechange = () => {
					if (installingWorker.state === 'installed') {
						if (navigator.serviceWorker.controller) {
							if (config && config.onUpdate) {
								config.onUpdate(registration);
							}
						} else if (config && config.onSuccess) {
							config.onSuccess(registration);
						}
					}
				};
			};
		})
		.catch((error) => {
			console.error('[Cadira] Error saat registrasi service worker:', error);
		});
}

function checkValidServiceWorker(swUrl, config) {
	fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
		.then((response) => {
			const contentType = response.headers.get('content-type');
			if (
				response.status === 404 ||
				(contentType != null && contentType.indexOf('javascript') === -1)
			) {
				navigator.serviceWorker.ready.then((registration) => {
					registration.unregister().then(() => {
						window.location.reload();
					});
				});
			} else {
				registerValidSW(swUrl, config);
			}
		})
		.catch(() => {
			console.warn(
				'[Cadira] Tidak ada koneksi internet. App berjalan dalam mode offline.'
			);
		});
}

// Interval cek update (30 menit)
const UPDATE_CHECK_INTERVAL = 30 * 60 * 1000;

/**
 * Periodic update check — dipanggil saat:
 * 1. App kembali visible (user switch back ke PWA)
 * 2. Interval berkala (setiap 30 menit)
 *
 * Memanggil registration.update() yang force browser cek
 * apakah service-worker.js berubah di server.
 */
function startPeriodicUpdateCheck(registration) {
	// Cek saat app kembali visible (resume dari background / switch app)
	document.addEventListener('visibilitychange', () => {
		if (document.visibilityState === 'visible') {
			registration.update().catch(() => {});
		}
	});

	// Cek berkala setiap 30 menit (untuk user yang buka app lama tanpa tutup)
	setInterval(() => {
		registration.update().catch(() => {});
	}, UPDATE_CHECK_INTERVAL);
}

export function register(config) {
	if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
		const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
		if (publicUrl.origin !== window.location.origin) return;

		window.addEventListener('load', () => {
			const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

			if (isLocalhost) {
				checkValidServiceWorker(swUrl, config);
				navigator.serviceWorker.ready.then(() => {});
			} else {
				registerValidSW(swUrl, config);
			}

			// Start periodic update check setelah SW terdaftar
			navigator.serviceWorker.ready.then((registration) => {
				startPeriodicUpdateCheck(registration);
			});
		});
	}
}

export function unregister() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready
			.then((registration) => {
				registration.unregister();
			})
			.catch((error) => {
				console.error(error.message);
			});
	}
}
